import React, { useEffect, useRef, useState } from "react";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "../../../components/modal/modal";
import ClipLoader from "react-spinners/ClipLoader";
import { theme } from "../../..";
import {
  changeCompulsion,
  deleteSection,
  editTestSeriesSection,
} from "../../../api/testSeries/testseries";
import Select from "react-select";
import Sections from "./Sections";
import { BiCheckboxChecked, BiCheckbox } from "react-icons/bi";
function RednerSingleSectionItem({
  OptionalSections,
  updateSectionAtIndex,
  deleteSectionFromStateAtIndex,
  item,
  setActiveSection,
  index,
  isActive,
  testSeriesId,
  secLength,
  sections,
  setOptionalSections,
  qcount,
}) {
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editSectionData, setEditSectionData] = useState(item);
  const [editingSection, setEditingSection] = useState(false);
  const [selectedSection, setSelectedSection] = useState([]);
  const [editOptionalSections, setEditOptionalSections] = useState([]);
  const titleInputRef = useRef(null);
  const compulsoryQuestionCountInputRef = useRef(null);
  const totalQuestionToBePublishedInputRef = useRef(null);
  const maxScoreInputRef = useRef(null);

  const [compulsion, setCompulsion] = useState(item?.optionalSection);
  const [compulsionLoader, setCompulsionLoader] = useState(false);
  useEffect(() => {
    setEditSectionData(item);
    setCompulsion(item?.optionalSection);
  }, [item?.id]);

  console.log(item);

  const handleSectionEditDataInput = (e) => {
    const sectionData = { ...editSectionData };
    sectionData[e.target.name] = e.target.value;
    setEditSectionData(sectionData);
  };

  const handleDeleteSection = () => {
    if (window.confirm("Are you sure you want to delete this section")) {
      deleteSection(item.id, index, deleteSectionFromStateAtIndex);
    }
  };

  const changeSectionCompulsion = async () => {
    setCompulsionLoader(true);
    if (
      window.confirm(
        compulsion
          ? "Are you sure you want make this section not compulsory?"
          : "Are you sure you want make this section compulsory?"
      )
    ) {
      const response = await changeCompulsion(!compulsion, item.id);
      if (response.status) {
        setCompulsion(!compulsion);
      }
    }
    setCompulsionLoader(false);
  };

  const editSectionHandler = (e) => {
    e.preventDefault();
    setEditingSection(true);
    editSectionData["id"] = item.id;
    editSectionData["testSeries"] = { id: testSeriesId };
    // const optionalSec=[]
    // selectedSection.map((val,i) =>{
    //     optionalSec.push(val.value)
    // })
    // editSectionData.optionalSections = [...optionalSec]
    editTestSeriesSection(editSectionData, (response) => {
      if (response.status === 200)
        updateSectionAtIndex({ ...item, ...editSectionData }, index);
    });
    setEditModalVisible(false);
    setEditingSection(false);
  };

  // const handleSelectChange = (data) => {
  //     setSelectedSection(data)
  // }

  useEffect(() => {
    const arr = [];
    const secArray = item.optionalSections;
    sections.map((val, i) => {
      const found = secArray?.find((ele) => ele == val.id);
      if (found) {
        const obj = {};
        obj.value = found;
        obj.label = val.title;
        arr.push(obj);
      }
    });
    setSelectedSection(arr);
  }, []);
  const checkOptions = () => {
    let newArr = [...OptionalSections];
    let obj = OptionalSections?.find((o, i) => {
      if (o.value === item.id) {
        newArr.splice(i, 1);
        return true;
      }
    });
    setEditOptionalSections(newArr);
  };
  return (
    <li class="nav-item" role="presentation">
      <a
        class={`nav-link ${isActive ? "active" : ""}`}
        id={`${item.title}-tab`}
        data-bs-toggle="tab"
        href="javascript:void(0)"
        onClick={() => setActiveSection(item)}
        role="tab"
        aria-controls={`${item.title}`}
        aria-selected="true"
      >
        <span>{item.title}</span>
        <span
          className="badge bg-primary rounded-pill ml-1 mr-1"
          style={{ color: "white" }}
        >
          {qcount}
        </span>
        <a
          className="mr-1 ml-1"
          onClick={() => {
            setEditModalVisible(true);
            checkOptions();
          }}
          href="javascript:;"
        >
          {/* bx:edit-alt */}
          <i class="bx bx-edit-alt" style={{ fontSize: 17 }}></i>
        </a>
        {/* <a
          className="mr-1 ml-1"
          onClick={handleDeleteSection}
          href="javascript:;"
        >
          <i class="bx bx-trash" style={{ fontSize: 17, color: "red" }}></i>
        </a> */}

        <a className="mr-1 ml-1" href="javascript:;">
          {/* <i
            class="iconify"
            data-icon="bx bx-check-box"
            style={{ fontSize: 17, color: "red" }}
          ></i> */}
          {compulsion ? (
            compulsionLoader ? (
              "..."
            ) : (
              <BiCheckboxChecked
                onClick={changeSectionCompulsion}
                style={{ fontSize: 20, marginTop: "-5px" }}
              />
            )
          ) : compulsionLoader ? (
            "..."
          ) : (
            <BiCheckbox
              onClick={changeSectionCompulsion}
              style={{ fontSize: 20, marginTop: "-5px" }}
            />
          )}
        </a>
      </a>
      <Modal
        visible={editModalVisible}
        setModalVisible={setEditModalVisible}
        modalId={"sectionEditModal" + item.id}
      >
        <form onSubmit={editSectionHandler}>
          <ModalHeader>
            <h5 class="modal-title" id="exampleModalLabel">
              Edit Section
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              {" "}
              <span aria-hidden="true">&times;</span>
            </button>
          </ModalHeader>
          <ModalBody>
            <div>
              <label>Section Name</label>
              <input
                ref={titleInputRef}
                className="form-control"
                value={editSectionData["title"]}
                name="title"
                required
                placeholder="Section Name"
                onChange={handleSectionEditDataInput}
              />
            </div>
            <div>
              <label>Compulsory Question Count</label>
              <input
                ref={compulsoryQuestionCountInputRef}
                className="form-control"
                value={editSectionData["compulsoryQuestions"]}
                name="compulsoryQuestions"
                required
                placeholder="Compulsory Question Count"
                onChange={handleSectionEditDataInput}
              />
            </div>
            <div>
              <label>Total Questions To be Published</label>
              <input
                ref={totalQuestionToBePublishedInputRef}
                className="form-control"
                value={editSectionData["totalQuestionToBePublished"]}
                name="totalQuestionToBePublished"
                required
                placeholder="Total Questions To Be Published Count"
                onChange={handleSectionEditDataInput}
              />
            </div>
            <div>
              <label>Max Score</label>
              <input
                ref={maxScoreInputRef}
                className="form-control"
                value={editSectionData["maxScore"]}
                name="maxScore"
                required
                placeholder="Max Score"
                onChange={handleSectionEditDataInput}
              />
            </div>
            {/* {secLength>1?(<div>
                            <label>Select Optional Section</label>
                            <Select name="languages" class="custom-select" id="validationCustom04"  placeholder="Select Optional Sections"  isMulti value={selectedSection} onChange={handleSelectChange} options={editOptionalSections}/>
                        </div>):(null)} */}
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              id="addPlaylistCloseBtn"
            >
              Close
            </button>
            <button class="btn btn-primary">
              {editingSection ? (
                <ClipLoader
                  color={theme.primaryColor}
                  loading={editingSection}
                />
              ) : (
                "Save changes"
              )}
            </button>
          </ModalFooter>
        </form>
      </Modal>
    </li>
  );
}

export default RednerSingleSectionItem;
